import { type Dispatch, useContext } from "react";
import {
  ImageCarouselActions,
  ImageCarouselContext,
  ImageCarouselDispatchContext,
  ImageCarouselState,
} from "src/contexts/image-carousel.context";

export function useImageCarouselContext(): ImageCarouselState {
  const imageCarouselContext = useContext(ImageCarouselContext);

  if (!imageCarouselContext) {
    throw new Error(
      "Please make sure you use useImageCarouselContext inside ImageCarouselProvider."
    );
  }

  return imageCarouselContext;
}
export function useImageCarouselDispatch(): Dispatch<ImageCarouselActions> {
  const imageCarouselDispatch = useContext(ImageCarouselDispatchContext);

  if (!imageCarouselDispatch) {
    throw new Error(
      "Please make sure you use useImageCarouselDispatch inside ImageCarouselProvider."
    );
  }

  return imageCarouselDispatch;
}
